import React, { Component } from 'react';
import './Note.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/**
 * NoteSettings - セッティング一覧の表示・編集コンポーネント
 * 
 * Props:
 *   - settings: [{ key, value }, ...] セッティング配列
 *   - onChange: (newSettings) => void セッティング変更時のコールバック
 *   - onLoadLastSetting: () => void 最新セッティングロードボタン押下時
 *   - isLoading: boolean ロード中フラグ
 */
export default class NoteSettings extends Component {

    // セッティング項目の変更
    handleChange = (index, field, value) => {
        const newSettings = [...this.props.settings];
        newSettings[index] = { ...newSettings[index], [field]: value };
        this.props.onChange(newSettings);
    }

    // セッティング項目の削除
    handleRemove = (index) => {
        const newSettings = this.props.settings.filter((_, i) => i !== index);
        this.props.onChange(newSettings);
    }

    // セッティング項目の追加
    handleAdd = () => {
        const newSettings = [...this.props.settings, { key: '', value: '' }];
        this.props.onChange(newSettings);
    }

    render() {
        const { settings, onLoadLastSetting, isLoading } = this.props;

        return (
            <div className="note-card">
                <div className="note-card-header">
                    <span>
                        <FontAwesomeIcon icon="cog" className="header-icon" />
                        セッティング一覧
                    </span>
                    <button
                        className="btn-load-setting"
                        onClick={onLoadLastSetting}
                        disabled={isLoading}
                    >
                        <FontAwesomeIcon icon="download" /> 最新をロード
                    </button>
                </div>
                <div className="note-card-body">
                    {settings.map((item, index) => (
                        <div key={index} className="setting-row">
                            <input
                                type="text"
                                placeholder="項目名"
                                value={item.key}
                                onChange={(e) => this.handleChange(index, 'key', e.target.value)}
                            />
                            <input
                                type="text"
                                placeholder="値"
                                value={item.value}
                                onChange={(e) => this.handleChange(index, 'value', e.target.value)}
                            />
                            <button
                                className="btn-remove"
                                onClick={() => this.handleRemove(index)}
                                title="削除"
                            >
                                <FontAwesomeIcon icon="times" />
                            </button>
                        </div>
                    ))}
                    <button className="btn-add-setting" onClick={this.handleAdd}>
                        <FontAwesomeIcon icon="plus" /> 項目を追加
                    </button>
                </div>
            </div>
        );
    }
}
